module.exports = __webpack_public_path__ + "static/media/bankbg.2d3de9a2.jpg";